<template>
    <div style="margin:0 -12px;">
        <div class="luna-header-box">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-1" style="padding-top:10px;">
                        <a href="/user/mod#8" class="link" style="font-size:28px;">
                            <i class="bi bi-x"></i>
                        </a>
                    </div>
                    <div class="col text-center">
                        <div style="padding-top:20px; ">
                            <b>相手の地域</b>
                        </div>
                    </div>
                    <div class="col-1">
                    </div>
                </div>
            </div>
        </div>
        <br />
        <div class="wrap">
            <div class="container" style="margin-top:34px;">
                <div class="row">
                    <div class="col">
                        <div class="row">
                            <div class="col px-0">
                                <div @click="user.conditions_area_0 = !user.conditions_area_0, setReset()"
                                    :class="user.conditions_area_0 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'">
                                    <div class="form-check" style="padding-left:10px;">
                                        <input class="form-check-input-luna" type="checkbox"
                                            v-model="user.conditions_area_0"
                                            style="width:16px;height:16px;float:none;margin-left:0;">
                                        <label class="form-check-label" style="font-size:14px">
                                            こだわらない
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--北海道-->
                        <div class="row">
                            <div class="col px-0">
                                <div class="l-accordion">
                                    <input id="ac1" type="checkbox">
                                    <label for="ac1" class="l-accordion-switch">
                                        <div class="luna-input-search-bar">
                                            <div class="form-check" style="padding-left:10px;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    北海道
                                                </label>
                                            </div>
                                        </div>
                                    </label>
                                    <div class="l-accordion-inside">
                                        <div @click="user.conditions_area_1 = !user.conditions_area_1, setAreaAc(1)"
                                            :class="user.conditions_area_1 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_1"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    北海道（札幌）
                                                </label>
                                            </div>
                                        </div>
                                        <div @click="user.conditions_area_2 = !user.conditions_area_2, setAreaAc(1)"
                                            :class="user.conditions_area_2 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_2"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    北海道（道東）
                                                </label>
                                            </div>
                                        </div>
                                        <div @click="user.conditions_area_3 = !user.conditions_area_3, setAreaAc(1)"
                                            :class="user.conditions_area_3 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_3"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    北海道（道南）
                                                </label>
                                            </div>
                                        </div>
                                        <div @click="user.conditions_area_4 = !user.conditions_area_4, setAreaAc(1)"
                                            :class="user.conditions_area_4 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_4"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    北海道（道北）
                                                </label>
                                            </div>
                                        </div>
                                        <div @click="user.conditions_area_5 = !user.conditions_area_5, setAreaAc(1)"
                                            :class="user.conditions_area_5 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_5"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    北海道（道央）
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!--東北-->
                        <div class="row">
                            <div class="col px-0">
                                <div class="l-accordion">
                                    <input id="ac2" type="checkbox">
                                    <label for="ac2" class="l-accordion-switch">
                                        <div class="luna-input-search-bar">
                                            <div class="form-check" style="padding-left:10px;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    東北
                                                </label>
                                            </div>
                                        </div>
                                    </label>
                                    <div class="l-accordion-inside">
                                        <div @click="user.conditions_area_6 = !user.conditions_area_6, setAreaAc(2)"
                                            :class="user.conditions_area_6 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_6"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    青森県
                                                </label>
                                            </div>
                                        </div>
                                        <div @click="user.conditions_area_7 = !user.conditions_area_7, setAreaAc(2)"
                                            :class="user.conditions_area_7 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_7"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    岩手県
                                                </label>
                                            </div>
                                        </div>
                                        <div @click="user.conditions_area_8 = !user.conditions_area_8, setAreaAc(2)"
                                            :class="user.conditions_area_8 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_8"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    宮城県
                                                </label>
                                            </div>
                                        </div>
                                        <div @click="user.conditions_area_9 = !user.conditions_area_9, setAreaAc(2)"
                                            :class="user.conditions_area_9 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_9"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    秋田県
                                                </label>
                                            </div>
                                        </div>
                                        <div @click="user.conditions_area_10 = !user.conditions_area_10, setAreaAc(2)"
                                            :class="user.conditions_area_10 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_10"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    山形県
                                                </label>
                                            </div>
                                        </div>
                                        <div @click="user.conditions_area_11 = !user.conditions_area_11, setAreaAc(2)"
                                            :class="user.conditions_area_11 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_11"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    福島県
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!--関東-->
                        <div class="row">
                            <div class="col px-0">
                                <div class="l-accordion">
                                    <input id="ac3" type="checkbox">
                                    <label for="ac3" class="l-accordion-switch">
                                        <div class="luna-input-search-bar">
                                            <div class="form-check" style="padding-left:10px;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    関東
                                                </label>
                                            </div>
                                        </div>
                                    </label>
                                    <div class="l-accordion-inside">
                                        <div @click="user.conditions_area_12 = !user.conditions_area_12, setAreaAc(3)"
                                            :class="user.conditions_area_12 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_12"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    茨城県
                                                </label>
                                            </div>
                                        </div>
                                        <div @click="user.conditions_area_13 = !user.conditions_area_13, setAreaAc(3)"
                                            :class="user.conditions_area_13 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_13"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    栃木県
                                                </label>
                                            </div>
                                        </div>
                                        <div @click="user.conditions_area_14 = !user.conditions_area_14, setAreaAc(3)"
                                            :class="user.conditions_area_14 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_14"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    群馬県
                                                </label>
                                            </div>
                                        </div>
                                        <div @click="user.conditions_area_15 = !user.conditions_area_15, setAreaAc(3)"
                                            :class="user.conditions_area_15 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_15"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    埼玉県
                                                </label>
                                            </div>
                                        </div>
                                        <div @click="user.conditions_area_16 = !user.conditions_area_16, setAreaAc(3)"
                                            :class="user.conditions_area_16 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_16"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    千葉県
                                                </label>
                                            </div>
                                        </div>
                                        <div @click="user.conditions_area_17 = !user.conditions_area_17, setAreaAc(3)"
                                            :class="user.conditions_area_17 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_17"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    東京都
                                                </label>
                                            </div>
                                        </div>
                                        <div @click="user.conditions_area_18 = !user.conditions_area_18, setAreaAc(3)"
                                            :class="user.conditions_area_18 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_18"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    神奈川県
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!--甲信越・北陸-->
                        <div class="row">
                            <div class="col px-0">
                                <div class="l-accordion">
                                    <input id="ac4" type="checkbox">
                                    <label for="ac4" class="l-accordion-switch">
                                        <div class="luna-input-search-bar">
                                            <div class="form-check" style="padding-left:10px;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    甲信越・北陸
                                                </label>
                                            </div>
                                        </div>
                                    </label>
                                    <div class="l-accordion-inside">
                                        <div @click="user.conditions_area_19 = !user.conditions_area_19, setAreaAc(4)"
                                            :class="user.conditions_area_19 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_19"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    新潟県
                                                </label>
                                            </div>
                                        </div>
                                        <div @click="user.conditions_area_20 = !user.conditions_area_20, setAreaAc(4)"
                                            :class="user.conditions_area_20 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_20"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    富山県
                                                </label>
                                            </div>
                                        </div>
                                        <div @click="user.conditions_area_21 = !user.conditions_area_21, setAreaAc(4)"
                                            :class="user.conditions_area_21 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_21"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    石川県
                                                </label>
                                            </div>
                                        </div>
                                        <div @click="user.conditions_area_22 = !user.conditions_area_22, setAreaAc(4)"
                                            :class="user.conditions_area_22 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_22"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    福井県
                                                </label>
                                            </div>
                                        </div>
                                        <div @click="user.conditions_area_23 = !user.conditions_area_23, setAreaAc(4)"
                                            :class="user.conditions_area_23 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_23"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    山梨県
                                                </label>
                                            </div>
                                        </div>
                                        <div @click="user.conditions_area_24 = !user.conditions_area_24, setAreaAc(4)"
                                            :class="user.conditions_area_24 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_24"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    長野県
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!--東海-->
                        <div class="row">
                            <div class="col px-0">
                                <div class="l-accordion">
                                    <input id="ac5" type="checkbox">
                                    <label for="ac5" class="l-accordion-switch">
                                        <div class="luna-input-search-bar">
                                            <div class="form-check" style="padding-left:10px;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    東海
                                                </label>
                                            </div>
                                        </div>
                                    </label>
                                    <div class="l-accordion-inside">
                                        <div @click="user.conditions_area_25 = !user.conditions_area_25, setAreaAc(5)"
                                            :class="user.conditions_area_25 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_25"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    岐阜県
                                                </label>
                                            </div>
                                        </div>
                                        <div @click="user.conditions_area_26 = !user.conditions_area_26, setAreaAc(5)"
                                            :class="user.conditions_area_26 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_26"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    静岡県
                                                </label>
                                            </div>
                                        </div>
                                        <div @click="user.conditions_area_27 = !user.conditions_area_27, setAreaAc(5)"
                                            :class="user.conditions_area_27 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_27"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    愛知県
                                                </label>
                                            </div>
                                        </div>
                                        <div @click="user.conditions_area_28 = !user.conditions_area_28, setAreaAc(5)"
                                            :class="user.conditions_area_28 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_28"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    三重県
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!--関西-->
                        <div class="row">
                            <div class="col px-0">
                                <div class="l-accordion">
                                    <input id="ac6" type="checkbox">
                                    <label for="ac6" class="l-accordion-switch">
                                        <div class="luna-input-search-bar">
                                            <div class="form-check" style="padding-left:10px;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    関西
                                                </label>
                                            </div>
                                        </div>
                                    </label>
                                    <div class="l-accordion-inside">
                                        <div @click="user.conditions_area_29 = !user.conditions_area_29, setAreaAc(6)"
                                            :class="user.conditions_area_29 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_29"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    滋賀県
                                                </label>
                                            </div>
                                        </div>
                                        <div @click="user.conditions_area_30 = !user.conditions_area_30, setAreaAc(6)"
                                            :class="user.conditions_area_30 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_30"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    京都府
                                                </label>
                                            </div>
                                        </div>
                                        <div @click="user.conditions_area_31 = !user.conditions_area_31, setAreaAc(6)"
                                            :class="user.conditions_area_31 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_31"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    大阪府
                                                </label>
                                            </div>
                                        </div>
                                        <div @click="user.conditions_area_32 = !user.conditions_area_32, setAreaAc(6)"
                                            :class="user.conditions_area_32 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_32"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    兵庫県
                                                </label>
                                            </div>
                                        </div>
                                        <div @click="user.conditions_area_33 = !user.conditions_area_33, setAreaAc(6)"
                                            :class="user.conditions_area_33 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_33"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    奈良県
                                                </label>
                                            </div>
                                        </div>
                                        <div @click="user.conditions_area_34 = !user.conditions_area_34, setAreaAc(6)"
                                            :class="user.conditions_area_34 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_34"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    和歌山県
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!--中国-->
                        <div class="row">
                            <div class="col px-0">
                                <div class="l-accordion">
                                    <input id="ac7" type="checkbox">
                                    <label for="ac7" class="l-accordion-switch">
                                        <div class="luna-input-search-bar">
                                            <div class="form-check" style="padding-left:10px;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    中国
                                                </label>
                                            </div>
                                        </div>
                                    </label>
                                    <div class="l-accordion-inside">
                                        <div @click="user.conditions_area_35 = !user.conditions_area_35, setAreaAc(7)"
                                            :class="user.conditions_area_35 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_35"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    鳥取県
                                                </label>
                                            </div>
                                        </div>
                                        <div @click="user.conditions_area_36 = !user.conditions_area_36, setAreaAc(7)"
                                            :class="user.conditions_area_36 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_36"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    島根県
                                                </label>
                                            </div>
                                        </div>
                                        <div @click="user.conditions_area_37 = !user.conditions_area_37, setAreaAc(7)"
                                            :class="user.conditions_area_37 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_37"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    岡山県
                                                </label>
                                            </div>
                                        </div>
                                        <div @click="user.conditions_area_38 = !user.conditions_area_38, setAreaAc(7)"
                                            :class="user.conditions_area_38 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_38"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    広島県
                                                </label>
                                            </div>
                                        </div>
                                        <div @click="user.conditions_area_39 = !user.conditions_area_39, setAreaAc(7)"
                                            :class="user.conditions_area_39 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_39"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    山口県
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!--四国-->
                        <div class="row">
                            <div class="col px-0">
                                <div class="l-accordion">
                                    <input id="ac8" type="checkbox">
                                    <label for="ac8" class="l-accordion-switch">
                                        <div class="luna-input-search-bar">
                                            <div class="form-check" style="padding-left:10px;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    四国
                                                </label>
                                            </div>
                                        </div>
                                    </label>
                                    <div class="l-accordion-inside">
                                        <div @click="user.conditions_area_40 = !user.conditions_area_40, setAreaAc(8)"
                                            :class="user.conditions_area_40 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_40"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    徳島県
                                                </label>
                                            </div>
                                        </div>
                                        <div @click="user.conditions_area_41 = !user.conditions_area_41, setAreaAc(8)"
                                            :class="user.conditions_area_41 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_41"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    香川県
                                                </label>
                                            </div>
                                        </div>
                                        <div @click="user.conditions_area_42 = !user.conditions_area_42, setAreaAc(8)"
                                            :class="user.conditions_area_42 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_42"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    愛媛県
                                                </label>
                                            </div>
                                        </div>
                                        <div @click="user.conditions_area_43 = !user.conditions_area_43, setAreaAc(8)"
                                            :class="user.conditions_area_43 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_43"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    高知県
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!--九州-->
                        <div class="row">
                            <div class="col px-0">
                                <div class="l-accordion">
                                    <input id="ac9" type="checkbox">
                                    <label for="ac9" class="l-accordion-switch">
                                        <div class="luna-input-search-bar">
                                            <div class="form-check" style="padding-left:10px;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    九州・沖縄
                                                </label>
                                            </div>
                                        </div>
                                    </label>
                                    <div class="l-accordion-inside">
                                        <div @click="user.conditions_area_44 = !user.conditions_area_44, setAreaAc(9)"
                                            :class="user.conditions_area_44 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_44"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    福岡県
                                                </label>
                                            </div>
                                        </div>
                                        <div @click="user.conditions_area_45 = !user.conditions_area_45, setAreaAc(9)"
                                            :class="user.conditions_area_45 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_45"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    佐賀県
                                                </label>
                                            </div>
                                        </div>
                                        <div @click="user.conditions_area_46 = !user.conditions_area_46, setAreaAc(9)"
                                            :class="user.conditions_area_46 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_46"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    長崎県
                                                </label>
                                            </div>
                                        </div>
                                        <div @click="user.conditions_area_47 = !user.conditions_area_47, setAreaAc(9)"
                                            :class="user.conditions_area_47 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_47"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    熊本県
                                                </label>
                                            </div>
                                        </div>
                                        <div @click="user.conditions_area_48 = !user.conditions_area_48, setAreaAc(9)"
                                            :class="user.conditions_area_48 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_48"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    大分県
                                                </label>
                                            </div>
                                        </div>
                                        <div @click="user.conditions_area_49 = !user.conditions_area_49, setAreaAc(9)"
                                            :class="user.conditions_area_49 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_49"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    宮崎県
                                                </label>
                                            </div>
                                        </div>
                                        <div @click="user.conditions_area_50 = !user.conditions_area_50, setAreaAc(9)"
                                            :class="user.conditions_area_50 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_50"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    鹿児島県
                                                </label>
                                            </div>
                                        </div>
                                        <div @click="user.conditions_area_51 = !user.conditions_area_51, setAreaAc(9)"
                                            :class="user.conditions_area_51 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'"
                                            style="padding-left:30px;">
                                            <div class="form-check" style="padding-left:10px;">
                                                <input class="form-check-input-luna" type="checkbox"
                                                    v-model="user.conditions_area_51"
                                                    style="width:16px;height:16px;float:none;margin-left:0;display:inline-block;">
                                                <label class="form-check-label" style="font-size:14px">
                                                    沖縄県
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col px-0">
                                <div @click="user.conditions_area_52 = !user.conditions_area_52"
                                    :class="user.conditions_area_52 ? 'luna-input-search-select-bar' : 'luna-input-search-bar'">
                                    <div class="form-check" style="padding-left:10px;">
                                        <input class="form-check-input-luna" type="checkbox"
                                            v-model="user.conditions_area_52"
                                            style="width:16px;height:16px;float:none;margin-left:0;">
                                        <label class="form-check-label" style="font-size:14px">
                                            海外
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid luna-footer-search-menu">
            <div class="row">
                <div class="col">
                    <div class="d-grid gap-2" style="padding: 0 5px;">
                        <button type="button" class="btn btn-luna-search" style="font-size:14px;" @click="setUsers()">
                            <div class="spinner-border" style="width: 1rem; height: 1rem;" role="status" v-if="is_click">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                            保存する
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            is_load: false,
            user: [],
            is_click: false,
        };
    },
    methods: {
        async init() {
            await axios.get("/api/auth/user/get")
                .then(
                    () => {
                        this.fetchUsers()
                    }
                )
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    }
                })
        },
        async fetchUsers() {
            await axios.get("/api/user/get/me")
                .then((response) => {
                    this.user = response.data.user

                    // 北海道
                    if (this.user.conditions_area_1) {
                        $('#ac1').prop('checked', true);
                    }
                    if (this.user.conditions_area_2) {
                        $('#ac1').prop('checked', true);
                    }
                    if (this.user.conditions_area_3) {
                        $('#ac1').prop('checked', true);
                    }
                    if (this.user.conditions_area_4) {
                        $('#ac1').prop('checked', true);
                    }
                    if (this.user.conditions_area_5) {
                        $('#ac1').prop('checked', true);
                    }

                    // 東北
                    if (this.user.conditions_area_6) {
                        $('#ac2').prop('checked', true);
                    }
                    if (this.user.conditions_area_7) {
                        $('#ac2').prop('checked', true);
                    }
                    if (this.user.conditions_area_8) {
                        $('#ac2').prop('checked', true);
                    }
                    if (this.user.conditions_area_9) {
                        $('#ac2').prop('checked', true);
                    }
                    if (this.user.conditions_area_10) {
                        $('#ac2').prop('checked', true);
                    }
                    if (this.user.conditions_area_11) {
                        $('#ac2').prop('checked', true);
                    }

                    // 関東
                    if (this.user.conditions_area_12) {
                        $('#ac3').prop('checked', true);
                    }
                    if (this.user.conditions_area_13) {
                        $('#ac3').prop('checked', true);
                    }
                    if (this.user.conditions_area_14) {
                        $('#ac3').prop('checked', true);
                    }
                    if (this.user.conditions_area_15) {
                        $('#ac3').prop('checked', true);
                    }
                    if (this.user.conditions_area_16) {
                        $('#ac3').prop('checked', true);
                    }
                    if (this.user.conditions_area_17) {
                        $('#ac3').prop('checked', true);
                    }
                    if (this.user.conditions_area_18) {
                        $('#ac3').prop('checked', true);
                    }

                    // 甲信越・北陸
                    if (this.user.conditions_area_19) {
                        $('#ac4').prop('checked', true);
                    }
                    if (this.user.conditions_area_20) {
                        $('#ac4').prop('checked', true);
                    }
                    if (this.user.conditions_area_21) {
                        $('#ac4').prop('checked', true);
                    }
                    if (this.user.conditions_area_22) {
                        $('#ac4').prop('checked', true);
                    }
                    if (this.user.conditions_area_23) {
                        $('#ac4').prop('checked', true);
                    }
                    if (this.user.conditions_area_24) {
                        $('#ac4').prop('checked', true);
                    }

                    // 東海
                    if (this.user.conditions_area_25) {
                        $('#ac5').prop('checked', true);
                    }
                    if (this.user.conditions_area_26) {
                        $('#ac5').prop('checked', true);
                    }
                    if (this.user.conditions_area_27) {
                        $('#ac5').prop('checked', true);
                    }
                    if (this.user.conditions_area_28) {
                        $('#ac5').prop('checked', true);
                    }

                    // 関西
                    if (this.user.conditions_area_29) {
                        $('#ac6').prop('checked', true);
                    }
                    if (this.user.conditions_area_30) {
                        $('#ac6').prop('checked', true);
                    }
                    if (this.user.conditions_area_31) {
                        $('#ac6').prop('checked', true);
                    }
                    if (this.user.conditions_area_32) {
                        $('#ac6').prop('checked', true);
                    }
                    if (this.user.conditions_area_33) {
                        $('#ac6').prop('checked', true);
                    }
                    if (this.user.conditions_area_34) {
                        $('#ac6').prop('checked', true);
                    }

                    // 中国
                    if (this.user.conditions_area_35) {
                        $('#ac7').prop('checked', true);
                    }
                    if (this.user.conditions_area_36) {
                        $('#ac7').prop('checked', true);
                    }
                    if (this.user.conditions_area_37) {
                        $('#ac7').prop('checked', true);
                    }
                    if (this.user.conditions_area_38) {
                        $('#ac7').prop('checked', true);
                    }
                    if (this.user.conditions_area_39) {
                        $('#ac7').prop('checked', true);
                    }

                    // 四国
                    if (this.user.conditions_area_40) {
                        $('#ac8').prop('checked', true);
                    }
                    if (this.user.conditions_area_41) {
                        $('#ac8').prop('checked', true);
                    }
                    if (this.user.conditions_area_42) {
                        $('#ac8').prop('checked', true);
                    }
                    if (this.user.conditions_area_43) {
                        $('#ac8').prop('checked', true);
                    }

                    // 九州
                    if (this.user.conditions_area_44) {
                        $('#ac9').prop('checked', true);
                    }
                    if (this.user.conditions_area_45) {
                        $('#ac9').prop('checked', true);
                    }
                    if (this.user.conditions_area_46) {
                        $('#ac9').prop('checked', true);
                    }
                    if (this.user.conditions_area_47) {
                        $('#ac9').prop('checked', true);
                    }
                    if (this.user.conditions_area_48) {
                        $('#ac9').prop('checked', true);
                    }
                    if (this.user.conditions_area_49) {
                        $('#ac9').prop('checked', true);
                    }
                    if (this.user.conditions_area_50) {
                        $('#ac9').prop('checked', true);
                    }
                    if (this.user.conditions_area_51) {
                        $('#ac9').prop('checked', true);
                    }

                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    }
                })
        },
        async setUsers() {
            this.is_load = true

            // v2 API (PUT /api/v2/user/profile) で保存する。
            // - region ID (`conditions_area_101`〜`_109`) は v2 で値域違反 (Rule::in([0, 1..52])) となるため送らない
            // - `conditions_area_0` (「こだわらない」) は単独で `[0]` として送る (v2 側で `@0a` token 保存)
            // - 個別 area (1〜52) は v-model フラグから配列化して送る
            // Vue の UI (チェックボックス・region 連動 setArea) はそのまま維持し、ペイロード生成だけ切替。
            const conditionsArea = this.user.conditions_area_0
                ? [0]
                : Array.from({ length: 52 }, (_, i) => i + 1)
                      .filter(id => this.user["conditions_area_" + id])

            await axios
                .put("/api/v2/user/profile", {
                    conditions_area: conditionsArea,
                })
                .then((response) => {
                    window.location.href = "/user/mod#8";
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("ユーザーの編集に失敗しました")
                    }
                })
        },
        setReset() {
            if (!this.user.conditions_area_0) {
                return
            }

            this.user.conditions_area_1 = false
            this.user.conditions_area_2 = false
            this.user.conditions_area_3 = false
            this.user.conditions_area_4 = false
            this.user.conditions_area_5 = false
            this.user.conditions_area_6 = false
            this.user.conditions_area_7 = false
            this.user.conditions_area_8 = false
            this.user.conditions_area_9 = false
            this.user.conditions_area_10 = false
            this.user.conditions_area_11 = false
            this.user.conditions_area_12 = false
            this.user.conditions_area_13 = false
            this.user.conditions_area_14 = false
            this.user.conditions_area_15 = false
            this.user.conditions_area_16 = false
            this.user.conditions_area_17 = false
            this.user.conditions_area_18 = false
            this.user.conditions_area_19 = false
            this.user.conditions_area_20 = false
            this.user.conditions_area_21 = false
            this.user.conditions_area_22 = false
            this.user.conditions_area_23 = false
            this.user.conditions_area_24 = false
            this.user.conditions_area_25 = false
            this.user.conditions_area_26 = false
            this.user.conditions_area_27 = false
            this.user.conditions_area_28 = false
            this.user.conditions_area_29 = false
            this.user.conditions_area_30 = false
            this.user.conditions_area_31 = false
            this.user.conditions_area_32 = false
            this.user.conditions_area_33 = false
            this.user.conditions_area_34 = false
            this.user.conditions_area_35 = false
            this.user.conditions_area_36 = false
            this.user.conditions_area_37 = false
            this.user.conditions_area_38 = false
            this.user.conditions_area_39 = false
            this.user.conditions_area_40 = false
            this.user.conditions_area_41 = false
            this.user.conditions_area_42 = false
            this.user.conditions_area_43 = false
            this.user.conditions_area_44 = false
            this.user.conditions_area_45 = false
            this.user.conditions_area_46 = false
            this.user.conditions_area_47 = false
            this.user.conditions_area_48 = false
            this.user.conditions_area_49 = false
            this.user.conditions_area_50 = false
            this.user.conditions_area_51 = false
            this.user.conditions_area_52 = false
        },
        setAreaAc(area) {
            // region フラグは UI から除去済のため、個別エリア クリック時の副作用は
            // 「こだわらない」(`conditions_area_0`) を解除するだけで良い。
            // `area` 引数は呼び出し側 (テンプレート) のシグネチャ互換のため残す。
            this.user.conditions_area_0 = false
        }
    },
    async created() {

        // 自動ログインチェック
        var arr = new Array();
        if (document.cookie != '') {
            var tmp = document.cookie.split('; ');
            for (var i = 0; i < tmp.length; i++) {
                var data = tmp[i].split('=');
                arr[data[0]] = decodeURIComponent(data[1]);
            }

            if (arr['uid'] != undefined) {
                await axios.get("/api/user/auth/" + arr['uid'])
                    .then(
                        (response) => {
                            this.init()
                        })
                    .catch((error) => {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    })
            }
            else {
                this.init()
            }
        }
        else {
            this.init()
        }
    },
};

</script>
<style scoped>
.link {
    color: #b3b3b3
}

.link:hover {
    color: #b3b3b3
}

.luna-header-box {
    box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
    position: fixed;
    height: 56px;
    width: 540px;
    top: 0;
    background-color: #fff;
    z-index: 999;
}

.luna-input-search-bar {
    padding: 15px;
    background-color: #fff;
    color: #333333;
    border-bottom: 1px solid #F2F2F2;
    border-top: 0px;
    border-left: 0px;
    border-right: 0px;
    border-radius: 0px;
}

.luna-input-search-select-bar {
    padding: 15px;
    background-color: #E7E7FF;
    color: #000000;
    border-bottom: 1px solid #fff;
    border-top: 0px;
    border-left: 0px;
    border-right: 0px;
    border-radius: 0px;
}



.l-accordion input {
    display: none;
}

.l-accordion .l-accordion-inside {
    opacity: 0;
    transition: 0.1s;
    height: 0;
    display: none;
}

.l-accordion input:checked~.l-accordion-inside {
    height: auto;
    opacity: 1;
    display: block;
}

.l-accordion .l-accordion-switch {
    position: relative;
    display: block;
    cursor: pointer;
}

.l-accordion .l-accordion-switch::before {
    content: url("/images/area_icon.svg");
    position: absolute;
    display: block;
    right: 10px;
    top: 13px;
    width: 28px;
    height: 28px;
}

.l-accordion .l-accordion-switch::before {
    transform: rotate(0);
    transform-origin: center center;
    transition: 0.5s;
}

.l-accordion input:checked~.l-accordion-switch::before {
    transform: rotate(180deg);
    transform-origin: center center;
    transition: 0.5s;
}

body {
    background-color: #fff;
}

.luna-footer-search-menu {
    position: fixed;
    bottom: 0;
    width: 538px;
    height: 80px;
    padding-top: 15px;
    z-index: 99999;
}

@media (max-width: 576px) {
    .luna-header-box {
        width: 100%;
    }

    .luna-footer-search-menu {
        width: 100%;
    }
}
</style>
